export const SUPPLIER_SURVEY_ASYNC = 'supplierSurvey/GET';
export const SUPPLIER_SURVEY = 'supplierSurvey/SET';
export const SUPPLIER_SURVEY_SUBMIT = 'supplierSurvey/SAVE';

export const SUPPLIER_SURVEY_ROOT_URL = '/supplier_survey_requests';
